//指定格式时间戳处理函数 formatTimestamp(timestamp, 'yyyy-MM-dd hh:mm:ss');
const formatTimestamp = (timestamp, format='yyyy-MM-dd hh:mm:ss') => {
    const date = new Date(timestamp);
    const map = {
        'yyyy': date.getFullYear(),
        'MM': (date.getMonth() + 1).toString().padStart(2, '0'),
        'dd': date.getDate().toString().padStart(2, '0'),
        'hh': date.getHours().toString().padStart(2, '0'),
        'mm': date.getMinutes().toString().padStart(2, '0'),
        'ss': date.getSeconds().toString().padStart(2, '0')
    };
    return format.replace(/(yyyy|MM|dd|hh|mm|ss)/g, (match) => map[match]);
}


export default { formatTimestamp }